// avstemming-shell-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avcs.common.cancel': 'Cancelar',
  'avcs.common.open': 'Abrir',
  'avcs.common.requestDocs': 'Solicitar documentación',
  'avcs.common.ofCount': '{done} de {total}',
  'avcs.common.unknown': 'Desconocido',
  'avcs.common.version': 'Versión {version}',
  'avcs.common.docsMissing': 'Faltan {count} documentos',
  'avcs.common.reset': 'Restablecer',
  'avcs.common.status': 'Estado',
  'avcs.common.period': 'Periodo',
  'avcs.common.responsible': 'Responsable',
  'avcs.common.deadline': 'Plazo',
  'avcs.common.client': 'Cliente',
  'avcs.common.deviation': 'Desviación',
  'avcs.common.deviations': '{count} desviaciones',
  'avcs.common.notRelevant': 'No relevante',
  'avcs.common.notStarted': 'Sin iniciar',
  'avcs.common.wholePeriodWord': 'Todo el periodo',
  'avcs.area.bank': 'Banco',
  'avcs.area.receivables': 'Cuentas por cobrar',
  'avcs.area.payables': 'Cuentas por pagar',
  'avcs.area.payroll': 'Nómina',
  'avcs.area.vat': 'IVA',
  'avcs.area.tax': 'Impuestos y tasas públicas',
  'avcs.area.assets': 'Activos',
  'avcs.area.loans': 'Préstamos y deudas',
  'avcs.area.equity': 'Patrimonio neto',
  'avcs.area.other': 'Resto del balance',
  'avcs.area.periodControls': 'Controles del periodo',
  'avcs.reason.externalBalanceMissing': 'Falta el saldo externo.',
  'avcs.reason.unexplainedDifference': 'La diferencia no está explicada.',
  'avcs.reason.explanationMissingReason': 'A una explicación le falta la justificación.',
  'avcs.reason.documentationMissing': 'Falta documentación: adjunta un justificante o escribe una nota.',
  'avcs.reason.lineAssessmentMissingComment': 'A la evaluación de un movimiento bancario le falta la justificación necesaria.',
  'avcs.reason.checklistIncomplete': 'Uno o más puntos de la lista de verificación profesional no están evaluados.',
  'avcs.reason.criticalDeviationUnexplained': 'Un punto crítico figura como desviación sin justificación.',
  'avcs.rollforward.opening': 'Saldo inicial',
  'avcs.rollforward.movement': 'Movimiento del periodo',
  'avcs.rollforward.closing': 'Saldo final',
  'avcs.rollforward.drift': 'No explicado por el saldo inicial y el movimiento',
  'avcs.kontroll.noDeadline': 'Sin plazo de revisión',
  'avcs.kontroll.overdueOne': 'Plazo de revisión {date} · vencido hace {days} día',
  'avcs.kontroll.overdueMany': 'Plazo de revisión {date} · vencido hace {days} días',
  'avcs.kontroll.today': 'Plazo de revisión hoy',
  'avcs.kontroll.inOne': 'Plazo de revisión {date} · en {days} día',
  'avcs.kontroll.inMany': 'Plazo de revisión {date} · en {days} días',
  'avcs.kontroll.bannerTitle': 'Revisión de {scope} · {period}',
  'avcs.kontroll.basisAt': ' · datos base a {time}',
  'avcs.kontroll.performedBy': 'Realizado por {name}',
  'avcs.kontroll.deviationsInBasis': '{count} desviaciones en la base',
  'avcs.kontroll.progress': 'Avance de la revisión: {done} de {total} puntos',
  'avcs.kontroll.reconProgress': 'Conciliación: {progress} % realizado',
  'avcs.kontroll.waitingDocs': 'A la espera de documentación: {request}',
  'avcs.kontroll.waitingDue': ' · plazo {date}',
  'avcs.kontroll.sendRequest': 'Enviar solicitud',
  'avcs.kontroll.whatMissing': 'Qué falta',
  'avcs.kontroll.whatMissingHint': 'La revisión se mantiene abierta, pero no puede aprobarse hasta que se responda a la solicitud.',
  'avcs.kontroll.whatMissingPlaceholder': 'Describe qué documentación necesitas para poder dar tu aval al trabajo',
  'avcs.kontroll.deadlineOptional': 'Plazo (opcional)',
  'avcs.kontroll.summaryTitle': 'Resumen de la revisión: {scope}',
  'avcs.kontroll.performedByLabel': 'Realizado por',
  'avcs.kontroll.versionLabel': 'Versión',
  'avcs.kontroll.dataBasis': 'Datos base',
  'avcs.kontroll.asOf': 'A {time}',
  'avcs.kontroll.materiality': 'Umbral de materialidad',
  'avcs.kontroll.notSet': 'Sin establecer',
  'avcs.kontroll.criticalDeviations': 'Desviaciones críticas',
  'avcs.kontroll.missingDocs': 'Documentación faltante',
  'avcs.kontroll.remainingRisk': 'Riesgo restante',
  'avcs.kontroll.notDescribed': 'Aún sin describir.',
  'avcs.kontroll.approvedByLabel': 'Aprobado por',
  'avcs.kontroll.periodContext': 'Contexto del periodo: {progress} % realizado · {avvik} desviaciones · faltan {mangler} documentos en total (no bloquea esta revisión)',
  'avcs.kontroll.noneOpen': 'No hay ninguna revisión abierta.',
  'avcs.kontroll.blockPerformer': 'Tú realizaste este trabajo y no puedes revisarlo.',
  'avcs.kontroll.blockUnassessed': '{count} puntos de revisión no están evaluados.',
  'avcs.kontroll.blockMustFixOne': '{count} punto figura como «Debe corregirse».',
  'avcs.kontroll.blockMustFixMany': '{count} puntos figuran como «Debe corregirse».',
  'avcs.kontroll.blockNoteEmpty': 'A una observación le falta el texto.',
  'avcs.kontroll.blockDocsRequest': 'La solicitud de documentos no se ha respondido.',
  'avcs.kontroll.blockConclusion': 'La revisión tiene desviaciones u observaciones. Entonces hay que redactar la conclusión.',
  'avcs.kontroll.blockAreaOpen': 'El área {area} no está completamente revisada.',
  'avcs.kontroll.blockAreasOpen': '{count} áreas del periodo no están completamente revisadas.',
  'avcs.kontroll.pointsAssessed': '{done} de {total} puntos evaluados',
  'avcs.kontroll.pointsBreakdown': '{ok} OK · {notes} observación · {mustFix} por corregir',
  'avcs.kontroll.performerNotice': 'Tú realizaste este trabajo y por eso no puedes revisarlo. Una revisión requiere a otra persona.',
  'avcs.kontroll.changedAfterNotice': 'La contabilidad se ha modificado después de aprobar la revisión. La aprobación sigue vigente, pero ya no se apoya en las cifras actuales.',
  'avcs.kontroll.returnedNotice': 'Devuelto al ejecutor: {note}',
  'avcs.kontroll.points': 'Puntos de revisión',
  'avcs.kontroll.noPoints': 'La revisión no tiene puntos.',
  'avcs.kontroll.approvedBy': 'Aprobado por {name}. {conclusion}',
  'avcs.kontroll.reviewerConclusion': 'Conclusión del revisor',
  'avcs.kontroll.conclusionPlaceholder': '¿En qué se basa la aprobación?',
  'avcs.kontroll.reopenPrompt': '¿Por qué se reabre la revisión?',
  'avcs.kontroll.reopen': 'Reabrir la revisión',
  'avcs.kontroll.markDocsReceived': 'Marcar la documentación como recibida',
  'avcs.kontroll.returnPlaceholder': '¿Qué hay que corregir?',
  'avcs.kontroll.returnToPerformer': 'Devolver al ejecutor',
  'avcs.kontroll.approveScope': 'Aprobar {scope}',
  'avcs.kontroll.approvePeriod': 'Aprobar el periodo',
  'avcs.kontroll.history': 'Historial',
  'avcs.cell.reconciled': 'Conciliado',
  'avcs.cell.notChecked': 'Sin revisar',
  'avcs.matrix.noResponsible': 'Sin responsable',
  'avcs.overall.done': 'Terminado',
  'avcs.overall.working': 'En curso',
  'avcs.matrix.sortBy': 'Ordenar por {name}',
  'avcs.matrix.noClients': 'Ningún cliente coincide con los filtros.',
  'avcs.matrix.progress': 'Avance',
  'avcs.matrix.org': 'Org. {org}',
  'avcs.matrix.noOrg': 'Sin n.º de organización',
  'avcs.matrix.openAreaFor': 'Abrir {area} de {client}',
  'avcs.matrix.openFolder': 'Abrir la carpeta',
  'avcs.matrix.noTasks': 'Ninguna tarea de conciliación abierta coincide con los filtros.',
  'avcs.activity.periodOpened': 'abrió el periodo',
  'avcs.activity.periodLocked': 'bloqueó el periodo',
  'avcs.activity.periodReopenedReason': 'reabrió el periodo – {reason}',
  'avcs.activity.periodReopened': 'reabrió el periodo',
  'avcs.activity.accountUpdatedStatus': 'actualizó la cuenta {account} ({status})',
  'avcs.activity.accountUpdated': 'actualizó la cuenta {account}',
  'avcs.activity.basisChanged': 'el saldo contabilizado de {account} cambió tras la conciliación',
  'avcs.activity.commentAdded': 'escribió un comentario',
  'avcs.activity.documentAddedOnAccount': 'adjuntó {file} a la cuenta {account}',
  'avcs.activity.documentAdded': 'adjuntó {file}',
  'avcs.activity.aDocument': 'un documento',
  'avcs.activity.documentRemoved': 'eliminó {file}',
  'avcs.activity.requestCreated': 'pidió al cliente {subject}',
  'avcs.activity.documentation': 'documentación',
  'avcs.activity.requestUpdated': 'actualizó una solicitud al cliente',
  'avcs.activity.none': 'Aún no hay actividad registrada en este periodo.',
  'avcs.comments.none': 'Aún no hay comentarios.',
  'avcs.comments.visibleToClient': 'Visible para el cliente',
  'avcs.comments.internal': 'Interno',
  'avcs.comments.placeholder': 'Escribe un comentario',
  'avcs.comments.add': 'Añadir',
  'avcs.panel.tab.documents': 'Documentos',
  'avcs.panel.tab.review': 'Revisión',
  'avcs.panel.tab.comments': 'Comentarios',
  'avcs.panel.tab.activity': 'Actividad',
  'avcs.panel.tab.requests': 'Solicitudes',
  'avcs.panel.notSent': 'El periodo aún no se ha enviado a revisión. «Enviar todo el periodo a revisión» está arriba del todo.',
  'avcs.panel.controlDue': ' · plazo {date}',
  'avcs.panel.controlPerformedBy': ' · realizado por {name}',
  'avcs.panel.openInReview': 'Abrir en el área de revisión',
  'avcs.panel.approvalNote': 'La aprobación y la devolución se hacen en el área de revisión. Debe aprobarlo alguien distinto de quien realizó el trabajo.',
  'avcs.panel.show': 'Mostrar panel',
  'avcs.panel.showing': 'Mostrando {account}',
  'avcs.panel.hide': 'Ocultar panel',
  'avcs.portfolio.title': 'Conciliación',
  'avcs.portfolio.subtitle': 'Haz el seguimiento de las conciliaciones de todos tus clientes.',
  'avcs.portfolio.viewMatrix': 'Matriz',
  'avcs.portfolio.viewTasks': 'Lista de tareas',
  'avcs.portfolio.refresh': 'Actualizar',
  'avcs.portfolio.searchClient': 'Buscar un cliente',
  'avcs.portfolio.allResponsible': 'Todos los responsables',
  'avcs.portfolio.allStatuses': 'Todos los estados',
  'avcs.portfolio.allDeadlines': 'Todos los plazos',
  'avcs.portfolio.next7': 'Próximos 7 días',
  'avcs.portfolio.deadlinePassed': 'Plazo vencido',
  'avcs.portfolio.next30': 'Próximos 30 días',
  'avcs.portfolio.clientGroup': 'Grupo de clientes',
  'avcs.portfolio.allClientGroups': 'Todos los grupos de clientes',
  'avcs.portfolio.onlyMine': 'Solo mis clientes',
  'avcs.portfolio.onlyDeviations': 'Solo desviaciones',
  'avcs.portfolio.moreFilters': 'Más filtros',
  'avcs.portfolio.emptyTitle': 'No hay clientes en este periodo',
  'avcs.portfolio.emptyText': 'O el despacho aún no tiene clientes activos, o el periodo es anterior a su fecha de incorporación. La fecha de incorporación se establece por cliente en Clientes.',
  'avcs.portfolio.clients': 'Clientes',
  'avcs.portfolio.kpiDone': 'Conciliado por completo',
  'avcs.portfolio.kpiWorking': 'En curso',
  'avcs.portfolio.kpiDeviations': 'Con desviaciones',
  'avcs.portfolio.kpiLocked': 'Periodos bloqueados',
  'avcs.portfolio.kpiDue7': 'Plazos en los próximos 7 días',
  'avcs.portfolio.showing': 'Mostrando: {filters}',
  'avcs.portfolio.openPointsIn': 'puntos abiertos en {areas}',
  'avcs.portfolio.removeFilter': 'Quitar filtro',
  'avcs.nav.areaTitle': '{area}: {extra}',
  'avcs.nav.contextOnly': 'Solo contexto: el área no forma parte de esta revisión',
  'avcs.nav.summary': 'Resumen',
  'avcs.nav.otherAreas': 'Otras áreas ({count})',
  'avcs.nav.otherAreasNote': 'Estas áreas no forman parte de esta revisión y solo se muestran como contexto del periodo.',
  'avcs.nav.showMenu': 'Mostrar menú',
  'avcs.nav.hideMenu': 'Ocultar menú',
  'avcs.header.backToReviewInbox': 'Volver a la bandeja de revisión',
  'avcs.header.exportReviewBasis': 'Exportar base de la revisión',
  'avcs.header.export': 'Exportar',
  'avcs.header.submitForReview': 'Enviar todo el periodo a revisión',
  'avcs.header.reopenPeriod': 'Reabrir el periodo',
  'avcs.header.completePeriod': 'Completar periodo',
  'avcs.header.openRequests': '{count} solicitudes abiertas',
  'avcs.header.responsible': 'Responsable: {name}',
  'avcs.summary.noAccounts': 'Sin cuentas',
  'avcs.summary.missingDocsShort': 'Faltan {count} docs.',
  'avcs.summary.openCount': '{count} abiertas',
  'avcs.summary.colArea': 'Área',
  'avcs.summary.colCompleted': 'Completado',
  'avcs.summary.colMissing': 'Faltan',
  'avcs.summary.noOpenDeviations': 'No hay desviaciones abiertas.',
  'avcs.summary.noExternalBalance': 'No se ha introducido saldo externo',
  'avcs.summary.unexplained': 'Sin explicar: {amount}',
  'avcs.summary.balanceChanged': 'El saldo contabilizado ha cambiado tras la conciliación',
  'avcs.summary.balanceChangedDetail': '{accounts}: la base no es la misma que cuando se concilió la cuenta.',
  'avcs.summary.reopenReconciliation': 'Reabrir la conciliación',
  'avcs.summary.progressByArea': 'Avance por área',
  'avcs.summary.openDeviations': 'Desviaciones abiertas',
  'avcs.workspace.explanationSaved': 'La explicación se ha guardado en el periodo.',
  'avcs.workspace.conclusionSaved': 'La conclusión se ha guardado.',
  'avcs.workspace.reopenPrompt': '¿Por qué se reabre el periodo?',
  'avcs.workspace.sentToReview': 'Enviado a revisión. Debe aprobarlo alguien distinto de ti.',
  'avcs.workspace.documentAttached': 'El documento se ha adjuntado.',
  'avcs.workspace.removeConfirm': '¿Quitar «{file}»? Las cuentas que apuntaban a él se quedan sin documentación.',
  'avcs.workspace.requestSent': 'La solicitud se ha enviado al cliente y se ha guardado en el periodo.',
  'avcs.workspace.requestSavedOnly': 'La solicitud se ha guardado en el periodo. No se añadió al diálogo con el cliente, así que avísale de otra manera.',
  'avcs.workspace.locked': 'El periodo está bloqueado. Para reabrirlo hace falta una justificación, que queda en el registro de actividad.',
  'avcs.workspace.noAccountsTitle': 'No hay cuentas de balance en este periodo',
  'avcs.workspace.noAccountsText': 'La conciliación se aplica a las cuentas de balance. Si el cliente aún no ha contabilizado nada, no hay nada que conciliar.',
  'avcs.workspace.accountLabel': 'cuenta {id}',
  'avcs.export.noAccounts': 'No hay cuentas que exportar en este periodo.',
});
